// src/store/customerMenuSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = 'https//api.monkeybox.ai/api/customermenus';

// Fetch customer menus optionally filtered by date
export const fetchCustomerMenus = createAsyncThunk(
  'customerMenus/fetchAll',
  async (date = '', { rejectWithValue }) => {
    try {
      const url = date ? `${API_BASE}?date=${date}` : API_BASE;
      const res = await axios.get(url);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create a new customer menu
export const createCustomerMenu = createAsyncThunk(
  'customerMenus/create',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_BASE, formData);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCustomerMenu = createAsyncThunk(
    'customerMenus/update',
    async ({ id, data }, { rejectWithValue }) => {
      try {
        console.log('🔁 PATCH payload:', { id, data }); 
        console.log("Json Stringify", JSON.stringify(data));
        const res = await axios.patch(`${API_BASE}/${id}`, data);
        return res.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

export const deleteCustomerMenu = createAsyncThunk(
    'customerMenus/delete',
    async (id, { rejectWithValue }) => {
      try {
        const res = await axios.delete(`${API_BASE}/${id}`);
        return { id, message: res.data.message };
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );

const customerMenuSlice = createSlice({
  name: 'customerMenu',
  initialState: {
    customerMenus: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetCustomerMenuState: (state) => {
      state.success = false;
      state.error = null;
    },
    addOptimisticMenu: (state, action) => {
      state.customerMenus.push(action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerMenus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomerMenus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customerMenus = action.payload;
      })
      .addCase(fetchCustomerMenus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createCustomerMenu.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.customerMenus.push(action.payload);
        state.success = true;
      })
      .addCase(createCustomerMenu.rejected, (state, action) => {
        state.isLoading = false; 
        state.error = action.payload;
        state.success = false;
      })
      .addCase(updateCustomerMenu.fulfilled, (state, action) => {
        console.log('✅ PATCH succeeded:', JSON.stringify(action.payload));
        const index = state.customerMenus.findIndex(cm => cm.id === action.payload.id);
        if (index !== -1) {
          state.customerMenus[index] = action.payload;
        }
        state.success = true;
      })
      .addCase(updateCustomerMenu.rejected, (state, action) => {
        console.log('❌ PATCH failed:', action.payload);
        state.error = action.payload;
        state.success = false;
      })
      .addCase(deleteCustomerMenu.fulfilled, (state, action) => {
        state.customerMenus = state.customerMenus.filter(cm => cm.id !== action.payload.id);
        state.success = true;
      })
      .addCase(deleteCustomerMenu.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      });
      ;
      
      
  },
});

export const { resetCustomerMenuState, addOptimisticMenu } = customerMenuSlice.actions;
export default customerMenuSlice.reducer;
